import { Box, Button, Flex, FormControl, FormLabel, Switch, Text } from "@chakra-ui/react"
import { useRouter } from "next/router"
import { useState } from "react"
import { fhAnalyticsUserActions, keys } from "../../../../../../../common/constants/constants"
import { useBrandedTranslation } from "../../../../../../../common/hooks/useBrandedTranslation"
import useKeyPress from "../../../../../../../common/hooks/useKeyPress"
import sendFhAnalytics from "../../../../../../../common/lib/fredhopper"
import { useUrlParams } from "../../../../../../../common/lib/UrlParamsContext"
import { FhResponseData } from "../../../../../../../common/types/search"

type Props = {
  filteredFiltersection: FhResponseData
  isOverlayFilters: boolean
  closeFiltersOverlay: () => void
  handleOnClose: () => void
  rid: string
  facetId: string
}

const ToggleFilterForm = ({
  filteredFiltersection,
  isOverlayFilters,
  closeFiltersOverlay,
  handleOnClose,
  rid,
  facetId,
}: Props) => {
  const { t } = useBrandedTranslation()
  const { setUrlParams } = useUrlParams()
  const { locale } = useRouter()

  const toggleFilterData = filteredFiltersection[0]
  const isToggleFilterDefaultSelected = !!toggleFilterData.selected
  const [isToggleSwitchChecked, setIsToggleSwitchChecked] = useState(isToggleFilterDefaultSelected)
  const [isCloseButtonActive, setIsCloseButtonActive] = useState(true)

  useKeyPress(
    keys.ENTER,
    () => {
      toggleFilterFormSubmit()
    },
    isCloseButtonActive
  )

  const toggleFilterFormSubmit = () => {
    if (!isCloseButtonActive) {
      setUrlParams(toggleFilterData.link.url_params)
    }

    //only send analytics if the new filter wasn't selected previously
    !toggleFilterData.selected &&
      sendFhAnalytics({
        locale,
        action: fhAnalyticsUserActions.FACETCLICK,
        sourceId: rid,
        facetId,
        facets: {
          prev: {},
          current: {
            [toggleFilterData?.value?.value]: true,
          },
        },
      })

    handleOnClose()
    if (isOverlayFilters) closeFiltersOverlay()
  }

  const handleToggleSwitchChange = () => {
    setIsToggleSwitchChecked((prevState) => !prevState)
    setIsCloseButtonActive((prevState) => !prevState)
  }

  return (
    <Flex direction="column" w="100%">
      <FormControl
        display="flex"
        alignItems="center"
        w="auto"
        px={isOverlayFilters ? { base: "4", sm: "6" } : "2"}
        py={isOverlayFilters ? { base: "2", sm: "4" } : "4"}
      >
        <Switch
          id="new-toggle"
          isChecked={isToggleSwitchChecked}
          variant="branded"
          onChange={handleToggleSwitchChange}
        ></Switch>
        <FormLabel htmlFor="new-toggle" mb="0" pl="4" cursor="pointer">
          <Text fontSize="sm" fontWeight="medium" color={isToggleSwitchChecked ? "gray.900" : "gray.500"}>
            {toggleFilterData.link.name}
          </Text>
        </FormLabel>
      </FormControl>
      <Box
        position="sticky"
        bottom={0}
        px={isOverlayFilters ? { base: "4", sm: "6" } : "2"}
        width="100%"
        bg="white"
        mt={isOverlayFilters ? { base: "6", sm: "4" } : "2"}
      >
        <Button mb="2" id="filter-footer-submit-button" variant="primary" width="100%" onClick={toggleFilterFormSubmit}>
          <Text fontSize="sm" fontWeight="medium">
            {isCloseButtonActive
              ? t("search-filters-close")
              : t("search-filters-view-results", {
                  count: isToggleSwitchChecked ? toggleFilterData.nr : 0,
                  n: isToggleSwitchChecked ? toggleFilterData.nr : "",
                })}
          </Text>
        </Button>
      </Box>
    </Flex>
  )
}

export default ToggleFilterForm
